import { Backdrop, Box, Stack, Typography, useTheme } from '@mui/material'
import { CSSProperties } from 'react'
import GroboticLight from '../../images/Grobotic png-lightmode.png'
import GroboticPng from '../../images/Grobotic png.png'
import './DataGridContext.css'

const CustomLoadingOverlay = ({
  open = false,
  bgColor,
  customLetters,
  stagingUpdates,
  imgStyle,
}: {
  open?: boolean
  bgColor?: string
  customLetters?: string[]
  stagingUpdates?: boolean
  imgStyle?: CSSProperties
}) => {
  const theme = useTheme()
  const defaultString = 'Loading Items'?.split('')
  const letters = customLetters ?? defaultString
  const lettersEnd = ['.', '.', '.']

  return (
    <Backdrop
      sx={{ color: theme.palette.mode === 'dark' ? 'white' : 'white', zIndex: theme => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          minHeight: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // bgcolor: bgColor ?? 'background.defaultdim',
          bgcolor: 'transparent',
          backdropFilter: 'blur(3px)',
          p: 2,
          borderRadius: 2,
        }}
      >
        <img
          className="loading-overlay"
          src={theme.palette.mode === 'dark' ? GroboticPng : GroboticLight}
          alt="logo"
          style={imgStyle ? imgStyle : { marginRight: 10 }}
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
          }}
        >
          {letters.map((char, index) => (
            <Typography
              key={index}
              className="animated-letter"
              style={{
                animationDelay: `${index * 0.1}s`,
                fontSize: 18,
              }}
            >
              {char}
            </Typography>
          ))}
          {lettersEnd.map((char, index) => (
            <Typography
              key={index}
              className="animated-letter-end"
              style={{
                animationDelay: `${index * 0.2}s`,
                fontSize: 20,
              }}
            >
              {char}
            </Typography>
          ))}
        </Box>
        {stagingUpdates && <Typography sx={{ color: 'text.warning' }}>Est. back live: 1:00PM - 1:10PM EST</Typography>}
      </Stack>
    </Backdrop>
  )
}

export default CustomLoadingOverlay
